export const ISRC_CHECK_SUCCESS = 'ISRC_CHECK_SUCCESS';
export const ISRC_CHECK_FAILURE = 'ISRC_CHECK_FAILURE';
export const ISRC_CHECK_REQUEST = 'ISRC_CHECK_REQUEST';
export const CIS_SUCCESS = 'CIS_SUCCESS';
export const CIS_FAILURE = 'CIS_FAILURE';
export const CIS_REQUEST = 'CIS_REQUEST';
